import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=795b4ce2&"
import script from "./Navigator.vue?vue&type=script&lang=ts&"
export * from "./Navigator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports